import React from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/authService';
import styles from './LogoutButton.module.css';

const LogoutButton = ({ className }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    // استفاده از سرویس مرکزی که ساختیم
    await authService.logout();
    
    // هدایت کاربر به صفحه لاگین
    navigate('/login');
  };

  return (
    <button 
      onClick={handleLogout} 
      className={`${styles.logoutBtn} ${className || ''}`}
      title="خروج امن از حساب کاربری"
    >
      {/* می‌توانیم اینجا یک آیکون SVG هم اضافه کنیم */}
      <svg 
        width="20" height="20" viewBox="0 0 24 24" fill="none" 
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      >
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
        <polyline points="16 17 21 12 16 7"></polyline>
        <line x1="21" y1="12" x2="9" y2="12"></line>
      </svg>
      <span>خروج</span>
    </button>
  );
};

export default LogoutButton;